var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.26,
    height: 17.26,
    viewBox: "0 0 17.26 17.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_48114",
    "data-name": "Group 48114",
    transform: "translate(-548.947 -301.81)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35936",
    "data-name": "Path 35936",
    d: "M6.678,14.475l1.559-1.559H9.8l1.06-1.06A5.068,5.068,0,1,0,7.741,8.743L2,14.475v3.119H5.119l1.559-1.559Z",
    transform: "translate(547.697 300.727)",
    fill: "none",
    stroke: "#385576",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35937",
    "data-name": "Path 35937",
    d: "M17.559,6.78A.78.78,0,1,1,16.78,6,.78.78,0,0,1,17.559,6.78Z",
    transform: "translate(544.612 299.844)",
    fill: "none",
    stroke: "#385576",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyIcon);
export default __webpack_public_path__ + "static/media/key_icon.b0b56e35.svg";
export { ForwardRef as ReactComponent };